// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap___J1F3","right":"styles_right__2PCkV"};